export const SUPPORT_EMAIL = 'privacy@johnsonjobs.com';

export const PROFILE_LOADER_TEXTS = [
  'Transforming your experience into a compelling career narrative',
  'Finalizing your personalized career profile',
];

export const DEFAULT_LOADER_TEXTS = ['Fetching information', 'Preparing content'];

export const STUB_DEFAULT_TEXTS = {
  mainText: 'NO RESULTS',
  subText: 'We searched far and wide and couldn’t find any positions matching your search',
};

export const STUB_ERROR_TEXTS = {
  mainText: 'TEMPORARILY UNAVAILABLE',
  subText: 'We couldn’t load positions right now. Please refresh the page in a minute',
};

export const HISTORY_STUB_TEXTS = {
  mainText: `No roles clicked yet`,
  subText: `Open a role from your weekly matches or while searching the site, and it'll be waiting here — with how many times you've come back to it.`,
};

export const HISTORY_SEARCH_STUB_TEXTS = {
  mainText: 'NO RESULTS',
  subText: 'Try a different title, company, or location',
};
